/* eslint-disable */
/*
 * @Author: wyh
 * @Date: 2020-04-20 17:21:33
 * @Last Modified by: wyh
 * @Last Modified time: 2020-04-27 13:47:40
 * @description: 自动根据页面域名获取接口域名
 */
const host = window.location.host
//h5页面域名
const HTML_HOST = {
  test: 'cdntest.yueyuechuxing.cn',
  public: host.includes('yueyuechuxing') ? 'h5.yueyuechuxing.cn' : 'h1.longjudj.com',
  // 有鹏老业务 正网单独域名
  800001: 'h5.youpengcx.com',
}

const TEST_COLLECTION = {
  HTML_HOST: 'cdntest.yueyuechuxing.cn',
  API_HOST: 'djapi-daily2.yueyuechuxing.cn'
}

const YY_DOMIN_COLLECTION = {
  pre2: {
    HTML_HOST: 'h5-pre.yueyuechuxing.cn',
    API_HOST: 'djapi-pre2.yueyuechuxing.cn'
  },
  pre: {
    HTML_HOST: 'h5-gray.yueyuechuxing.cn',
    API_HOST: 'djapi-pre.yueyuechuxing.cn'
  },
  public: {
    HTML_HOST: 'h5.yueyuechuxing.cn',
    API_HOST: 'djapi.yueyuechuxing.cn'
  }
}

const LJ_DOMIN_COLLECTION = {
  pre2: {
    HTML_HOST: 'h5-pre.yueyuechuxing.cn',
    API_HOST: 'api-pre2.longjudj.com'
  },
  pre: {
    HTML_HOST: 'h5-gray.yueyuechuxing.cn',
    API_HOST: 'api-pre.longjudj.com'
  },
  public: {
    HTML_HOST: 'h1.longjudj.com',
    API_HOST: 'api.longjudj.com'
  }
}

// 根据当前访问路径 输出 当前环境
function getEnvKey() {
  const { pathname } = window.location
  const hostEnumArr = ['pre2', 'pre', 'public']
  const env = hostEnumArr.find(key => {
    if(pathname.includes(`/${key}/`)) {
      return true
    }
    return false
  }) || 'public'
  return env
}

function isTest() {
  const host = window.location.host;
  return !host || host.includes('localhost') || host.indexOf('test') !== -1 || /^[0-9.:]+$/.test(host);
}


function getDominInfo() {
  const { host } = window.location;
  // 小程序司机招募存在h1.longju.com 域名，根据同源策略需要走对应的域名请求
  const dominMap = host.includes('yueyuechuxing') ? YY_DOMIN_COLLECTION : LJ_DOMIN_COLLECTION;
  const env = getEnvKey();
  const apiHost = isTest() ? TEST_COLLECTION['API_HOST'] : dominMap[env]['API_HOST'];
  const htmlHost = isTest() ? TEST_COLLECTION['HTML_HOST'] : dominMap[env]['HTML_HOST']
  return {
    apiHost,
    htmlHost
  }
}

// 返回值 带协议https:// | http://
function getApiHost() {
  const apiHost = getDominInfo().apiHost
  const apiBaseUrl = `${window.location.protocol}//${apiHost}`;
  return apiBaseUrl;
}

// 返回值 带协议https:// | http://
function getComtextHTMLHost() {
  const htmlHost = getDominInfo().htmlHost
  const htmlBaseUrl = `${window.location.protocol}//${htmlHost}`;
  return htmlBaseUrl;
}

// 判断H5正测网
function getHTMLHost() {
  const apiHost = isTest() ? HTML_HOST['test'] : HTML_HOST['public'];
  const apiBaseUrl = `${window.location.protocol}//${apiHost}`;
  return apiBaseUrl;
}

export {
  getApiHost,
  getHTMLHost,
  getComtextHTMLHost,
  isTest
}
